import { render } from "./ImgLogoCompetence.vue?vue&type=template&id=1182dd20"
import script from "./ImgLogoCompetence.vue?vue&type=script&lang=js"
export * from "./ImgLogoCompetence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__